module.exports = __webpack_public_path__ + "img/typeTip.15b2afc4.jpg";